"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusRings = void 0;
var _colorOptions = require("../colorOptions");
/* eslint-disable typescript-sort-keys/interface */
/* eslint-disable sort-keys */

var focusRings = exports.focusRings = {
  gray: {
    gray100: "0px 0px 0px 4px ".concat(_colorOptions.imColors.gray100),
    gray500: "0px 0px 0px 4px ".concat(_colorOptions.imColors.gray500)
  },
  primary: {
    primary100: "0px 0px 0px 4px ".concat(_colorOptions.imColors.primary100),
    primary500: "0px 0px 0px 4px ".concat(_colorOptions.imColors.primary500)
  },
  error: {
    error100: "0px 0px 0px 4px ".concat(_colorOptions.imColors.error100)
  }
};